// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AccountAddressesController from "./account_addresses_controller"
application.register("account-addresses", AccountAddressesController)

import AccountChartsController from "./account_charts_controller"
application.register("account-charts", AccountChartsController)

import AccountChartsFilterController from "./account_charts_filter_controller"
application.register("account-charts-filter", AccountChartsFilterController)

import AccountContactsController from "./account_contacts_controller"
application.register("account-contacts", AccountContactsController)

import AccountCostCentresController from "./account_cost_centres_controller"
application.register("account-cost-centres", AccountCostCentresController)

import AccountReceivablesController from "./account_receivables_controller"
application.register("account-receivables", AccountReceivablesController)

import AccountTariffsController from "./account_tariffs_controller"
application.register("account-tariffs", AccountTariffsController)

import ActivitiesStatisticsController from "./activities_statistics_controller"
application.register("activities-statistics", ActivitiesStatisticsController)

import AddressAutocompleteController from "./address_autocomplete_controller"
application.register("address-autocomplete", AddressAutocompleteController)

import AsyncLoadController from "./async_load_controller"
application.register("async-load", AsyncLoadController)

import BizCorePaymentsController from "./biz_core_payments_controller"
application.register("biz-core-payments", BizCorePaymentsController)

import BpointDirectDebitsController from "./bpoint_direct_debits_controller"
application.register("bpoint-direct-debits", BpointDirectDebitsController)

import BpointPaymentsController from "./bpoint_payments_controller"
application.register("bpoint-payments", BpointPaymentsController)

import BrandChartsController from "./brand_charts_controller"
application.register("brand-charts", BrandChartsController)

import BrandsSearchController from "./brands_search_controller"
application.register("brands-search", BrandsSearchController)

import CallsController from "./calls_controller"
application.register("calls", CallsController)

import CallsPerDayController from "./calls_per_day_controller"
application.register("calls-per-day", CallsPerDayController)

import CompleteRegistrationController from "./complete_registration_controller"
application.register("complete-registration", CompleteRegistrationController)

import ConfirmController from "./confirm_controller"
application.register("confirm", ConfirmController)

import CreditCardsController from "./credit_cards_controller"
application.register("credit-cards", CreditCardsController)

import DirectDebitBankAccountsController from "./direct_debit_bank_accounts_controller"
application.register("direct-debit-bank-accounts", DirectDebitBankAccountsController)

import DirectDebitTypesController from "./direct_debit_types_controller"
application.register("direct-debit-types", DirectDebitTypesController)

import DirectDebitsController from "./direct_debits_controller"
application.register("direct-debits", DirectDebitsController)

import DirectToViewTabController from "./direct_to_view_tab_controller"
application.register("direct-to-view-tab", DirectToViewTabController)

import ExportFilesController from "./export_files_controller"
application.register("export-files", ExportFilesController)

import EzidebitBankAccountController from "./ezidebit_bank_account_controller"
application.register("ezidebit-bank-account", EzidebitBankAccountController)

import EzidebitCreditCardController from "./ezidebit_credit_card_controller"
application.register("ezidebit-credit-card", EzidebitCreditCardController)

import EzidebitPayNowController from "./ezidebit_pay_now_controller"
application.register("ezidebit-pay-now", EzidebitPayNowController)

import EzidebitSignupAndPayController from "./ezidebit_signup_and_pay_controller"
application.register("ezidebit-signup-and-pay", EzidebitSignupAndPayController)

import FatZebraDirectDebitsController from "./fat_zebra_direct_debits_controller"
application.register("fat-zebra-direct-debits", FatZebraDirectDebitsController)

import ForgotPasswordController from "./forgot_password_controller"
application.register("forgot-password", ForgotPasswordController)

import FormController from "./form_controller"
application.register("form", FormController)

import HotwireModalController from "./hotwire_modal_controller"
application.register("hotwire-modal", HotwireModalController)

import InternetUsagesController from "./internet_usages_controller"
application.register("internet-usages", InternetUsagesController)

import InvoiceItemisationController from "./invoice_itemisation_controller"
application.register("invoice-itemisation", InvoiceItemisationController)

import InvoicePdfsController from "./invoice_pdfs_controller"
application.register("invoice-pdfs", InvoicePdfsController)

import LatestChargesController from "./latest_charges_controller"
application.register("latest-charges", LatestChargesController)

import MaterialDesignController from "./material_design_controller"
application.register("material-design", MaterialDesignController)

import MyobDirectDebitsController from "./myob_direct_debits_controller"
application.register("myob-direct-debits", MyobDirectDebitsController)

import MyobPaymentsController from "./myob_payments_controller"
application.register("myob-payments", MyobPaymentsController)

import NabCreditCardsController from "./nab_credit_cards_controller"
application.register("nab-credit-cards", NabCreditCardsController)

import NabV2MicroformController from "./nab_v2_microform_controller"
application.register("nab-v2-microform", NabV2MicroformController)

import PaymentsController from "./payments_controller"
application.register("payments", PaymentsController)

import PhlexSelect2Controller from "./phlex_select2_controller"
application.register("phlex-select2", PhlexSelect2Controller)

import RecentInvoicesController from "./recent_invoices_controller"
application.register("recent-invoices", RecentInvoicesController)

import RequiredController from "./required_controller"
application.register("required", RequiredController)

import Select2Controller from "./select2_controller"
application.register("select2", Select2Controller)

import ServicesController from "./services_controller"
application.register("services", ServicesController)

import UpdatePasswordController from "./update_password_controller"
application.register("update-password", UpdatePasswordController)

import WestpacController from "./westpac_controller"
application.register("westpac", WestpacController)
